module.exports = require('./lib/Winwheel');